import { BasePlatform } from '../platform';
import { WebStorage } from './storage';

export class WebPlatform extends BasePlatform {
    constructor() {
        super();
        this.storage = new WebStorage();
    }

    async saveData(key, value) {
        return this.storage.set(key, value);
    }

    async getData(key) {
        return this.storage.get(key);
    }

    async removeData(key) {
        return this.storage.remove(key);
    }

    async getImageData(source) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;
                
                ctx.drawImage(img, 0, 0);
                resolve(ctx.getImageData(0, 0, img.width, img.height));
            };
            
            img.onerror = reject;
            img.src = source;
        });
    }

    getPlatformInfo() {
        return {
            type: 'web',
            userAgent: navigator.userAgent,
            screenSize: {
                width: window.innerWidth,
                height: window.innerHeight
            }
        };
    }

    navigate(path) {
        window.location.href = path;
    }
}